var _rect, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 34,
    width: 144,
    height: 86,
    rx: 10,
    fill: "#fff",
    stroke: "#F97316",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 50h144",
    stroke: "#F97316",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 42,
    r: 2.6,
    fill: "#FDBA74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 42,
    r: 2.6,
    fill: "#FFEDD5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 42,
    r: 2.6,
    fill: "#FFEDD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 64 l-14 12 14 12",
    stroke: "#F59E0B",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 64 l14 12 -14 12",
    stroke: "#F59E0B",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134 60 l-8 32",
    stroke: "#F97316",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 66,
    width: 34,
    height: 8,
    rx: 3,
    fill: "#FFEDD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 80,
    width: 24,
    height: 8,
    rx: 3,
    fill: "#FFF7ED",
    stroke: "#F97316",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotnet);
export default __webpack_public_path__ + "static/media/dotnet.c23e319b93d82f2e70ab0144a343cabe.svg";
export { ForwardRef as ReactComponent };